import { snapshot, useSnapshot } from 'valtio'
import { type ReactElement, useEffect } from 'react'
import Head from 'next/head'
import { proxyGlobalAuth } from '../proxies/proxyGlobalAuth'
import { GlobalSiteDomainEnum } from '../types/GlobalSiteDomainEnum'
import InverseSignatureLogo from '../components/ui/logos/InverseSignatureLogo'
import StandardPayInverseSignatureLogo from '../components/ui/logos/StandardPayInverseSignatureLogo'
import BackgroundGraphic from '../components/ui/logos/BackgroundGraphic'
import StandardPayBackgroundGraphic from '../components/ui/logos/StandardPayBackgroundGraphic'
import StandardPayGlyphLogo from '../components/ui/logos/StandardPayGlyphLogo'
import WastePayGlyphLogo from '../components/ui/logos/WastePayGlyphLogo'
import PrimarySignatureLogo from '../components/ui/logos/PrimarySignatureLogo'
import StandardPayPrimarySignatureLogo from '../components/ui/logos/StandardPayPrimarySignatureLogo'
import { retrieveSiteDomainEnum } from '../utils/domainUtils'

export function DetermineLogo (): ReactElement {
  const { siteDomainEnum } = useSnapshot(proxyGlobalAuth)
  if (siteDomainEnum === GlobalSiteDomainEnum.WastePay) {
    return <WastePayGlyphLogo />
  }
  return <StandardPayGlyphLogo />
}

export function DetermineInverseColorIconPoweredBy (): ReactElement {
  const { siteDomainEnum } = useSnapshot(proxyGlobalAuth)
  if (siteDomainEnum === GlobalSiteDomainEnum.WastePay) {
    return <InverseSignatureLogo />
  }
  return <StandardPayInverseSignatureLogo />
}

export function DeterminePrimaryColorIconPoweredBy ({ theme }: { theme: GlobalSiteDomainEnum }): ReactElement {
  if (theme === GlobalSiteDomainEnum.WastePay) {
    return <PrimarySignatureLogo />
  }
  return <StandardPayPrimarySignatureLogo />
}

export function DetermineBrowserTabLogo (): ReactElement {
  const { siteDomainEnum } = useSnapshot(proxyGlobalAuth)
  useEffect(() => {
    proxyGlobalAuth.siteDomainEnum = retrieveSiteDomainEnum()
  }, [])
  if (siteDomainEnum === GlobalSiteDomainEnum.WastePay) {
    return (
      <Head>
        <link rel="icon" type="image/x-icon" href="/wastepay-icons/favicon.ico" />
        <link rel="apple-touch-icon" sizes="180x180" href="/wastepay-icons/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/wastepay-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/wastepay-icons/favicon-16x16.png" />
        <link rel="manifest" href="/wastepay-icons/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />
      </Head>
    )
  } else {
    return (
      <Head>
        <link rel="icon" type="image/x-icon" href="/standardpay-icons/favicon.ico" />
        <link rel="apple-touch-icon" sizes="180x180" href="/standardpay-icons/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/standardpay-icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/standardpay-icons/favicon-16x16.png" />
        <link rel="manifest" href="/standardpay-icons/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />
      </Head>
    )
  }
}

export function DeterminedSignatureLogo ({ theme }: { theme: GlobalSiteDomainEnum }): ReactElement {
  if (theme === GlobalSiteDomainEnum.WastePay) {
    return <InverseSignatureLogo />
  }
  return <StandardPayInverseSignatureLogo />
}

export function DeterminedBackgroundGraphic ({ theme }: { theme: GlobalSiteDomainEnum }): ReactElement {
  if (theme === GlobalSiteDomainEnum.WastePay) {
    return <BackgroundGraphic />
  }
  return <StandardPayBackgroundGraphic />
}
export function determineBrowserTabName (): string {
  const { siteDomainEnum } = snapshot(proxyGlobalAuth)
  if (siteDomainEnum === GlobalSiteDomainEnum.WastePay) {
    return 'WastePay'
  }
  return 'StandardPay'
}
